export function Footer() {
  return (
    <footer className="footer">
      <p>
        <span className="footer-strong">This verifier runs entirely in your browser.</span> No
        receipt content is sent to Sequesign or any other service. The verification logic is the
        reference implementation from
        <code> src/lib/verify.ts</code>.
      </p>
      <p>
        Sequesign receipts can be verified offline against the published public keys of the agent
        and witness. This UI is one way to do that; the verifier library itself runs anywhere Node
        or a modern browser runs.
      </p>
      <div className="footer-legal">
        <a href="https://sequesign.com/terms">Terms</a>
        <a href="https://sequesign.com/privacy">Privacy</a>
        <a href="https://sequesign.com/cookies">Cookie Notice</a>
        <a href="https://sequesign.com/do-not-sell">Do Not Sell or Share</a>
        <a href="https://sequesign.com/subprocessors">Sub-processors</a>
        <a href="https://sequesign.com/security">Security</a>
        <a href="https://sequesign.com/dmca">DMCA</a>
        <a href="https://sequesign.com/dpa">DPA</a>
        <a href="https://sequesign.com/changelog">Changelog</a>
        <a href="https://sequesign.com/contact">Contact</a>
      </div>
    </footer>
  );
}
